const responseHandleErrorLogic = async (error, app) => {
  let { message } = error;

  if (error.response) {
    const { config = {}, data } = error.response;

    if (config.hideToast) {
      return Promise.resolve();
    }

    if (data) {
      if (['VALIDATION_ERROR', 'DETAIL_ERROR_ARRAY', 'ASN_VALIDATION_ERROR'].includes(data.type)) {
        const locale = app.$i18n.locale || 'en';
        const translate = (data.type === 'VALIDATION_ERROR')
          ? app.$i18n.t.bind(app.$i18n)
          : (t, v) => v.message;

        error.translatedErrorList = (data.data || []).map((item) => ({
          [locale]: translate('validation.error_at_field', item),
        }));

        if (data.type === 'VALIDATION_ERROR') {
          let msg;
          if (error.translatedErrorList.length) {
            msg = error.translatedErrorList[0][locale];
          } else {
            msg = translate('validation.default');
          }

          app.$toast(msg, {
            title: app.$t('toast.danger'),
            variant: 'danger',
          });
        }

        // We should handle this type separately
        return Promise.reject(error);
      }

      if (data.message) {
        message = data.message;
      } else if (error.request.responseType === 'blob'
        && data.type === 'application/json') {
        let blobError;
        try {
          const resText = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
              resolve(reader.result);
            };
            reader.readAsText(data);
          });

          blobError = JSON.parse(resText);
        } finally {
          if (blobError && blobError.message) {
            message = blobError.message;
          }
        }
      }
    }
  }

  app.$toast(message, {
    title: app.$t('toast.danger'),
    variant: 'danger',
  });

  return Promise.resolve();
};

export default responseHandleErrorLogic;
